import { useCallback } from "react";
import { CheckMarkIcon } from "@fluentui/react-icons-mdl2";
import { INavLink, Nav } from "@fluentui/react/lib/Nav";
import { Stack } from "@fluentui/react/lib/Stack";
import { IRenderFunction } from "@fluentui/react/lib/Utilities";

import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { INavigationProps } from "./INavigationProps";
import { useNavigationStyles } from "./UseNavigationStyles";
import { useNavigationItems } from "./UseNavigationItems";

export const Navigation = WithTheme((props: INavigationProps): JSX.Element => {
  const {
    project,
    theme: { spacing }
  } = props;
  const styles = useNavigationStyles();
  const { navigationItems, selectedNavigationItemId } = useNavigationItems(project);

  const onRenderLink = useCallback(
    (p: INavLink, defaultRenderer: IRenderFunction<INavLink>) => (
      <Stack grow horizontal horizontalAlign="space-between" className={styles.item}>
        <Stack.Item grow className={styles.itemText}>
          {defaultRenderer(p)}
        </Stack.Item>
        <Stack.Item disableShrink className={styles.itemCheck}>
          {(p.checked as boolean) ? <CheckMarkIcon /> : null}
        </Stack.Item>
      </Stack>
    ),
    [styles]
  );

  return (
    <Stack disableShrink className={styles.root}>
      <Stack grow className={styles.items} tokens={{ childrenGap: spacing.s2 }}>
        <Nav
          selectedKey={selectedNavigationItemId}
          className={styles.navIcon}
          groups={navigationItems}
          onRenderLink={onRenderLink}
        />
      </Stack>
    </Stack>
  );
});
